import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "test-header"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "part" }, "PART", -1)
const _hoisted_3 = { class: "number" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "LISTENING COMPREHENSION", -1)
const _hoisted_5 = {
  key: 1,
  class: "test-pager"
}
const _hoisted_6 = {
  key: 0,
  class: "test",
  ref: "main"
}
const _hoisted_7 = { class: "test-title" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("練習問題"),
  /*#__PURE__*/_createElementVNode("rp", null, "（"),
  /*#__PURE__*/_createElementVNode("rt", null, "れんしゅうもんだい"),
  /*#__PURE__*/_createElementVNode("rp", null, "）")
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "text" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "test-section" }

import {inject, onMounted, ref, Ref } from "vue"
import { useRoute, useRouter } from 'vue-router'
import gsap from 'gsap'
import Answer from '@/components/parts/Answer.vue'
import Layout1 from '@/components/question/Layout1.vue'
import Layout2 from '@/components/question/Layout2.vue'
import Layout3 from '@/components/question/Layout3.vue'
import Layout6 from '@/components/question/Layout6.vue'
import Layout8 from '@/components/question/Layout8.vue'
import Progress from '@/components/parts/Progress.vue'
import Countdown from "@/components/parts/Countdown.vue"
import RetryModal from "@/components/parts/RetryModal.vue"
import { appKey, examKey } from "@/main";
import { Page, Part } from "@/store/exam";
import DemoControl from "@/components/parts/DemoControl.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ListeningTest',
  emits: ['overridePageName'],
  setup(__props, { emit }) {

const app = inject(appKey);
const exam = inject(examKey);


const route = useRoute();
const router = useRouter();

const baseAudioUrl = exam?.getAudioUrl();

const currentPage: Ref<number> = ref(1);
const currentAudioName: Ref<string> = ref('');
const question: Ref<Page | null> = ref(null);
const part: Ref<Part | null> = ref(null);
const mounted = ref(false);
const selected = ref(0);
const currentPartQuestions: Ref<Page[] | null> = ref(null);
let countdownTimerId: number | null = null;
const countdown = ref(false);
const showRetryModal = ref(false);

const jingleTime = ref(0);
const isExample = ref(false)

const group = route.params.group;

const demo = exam?.isDemo();

// ページ更新
const updatePage = async (page: number) => {
  if (!app || !exam) return;
  app.log(`ListeningTest updatePage ${page}`);

  try {
    currentPage.value = page;

    const questions = await exam.questions();
    const nextPart = questions.listening.parts.filter(x => x.partNumber == questions.listening.pages[page].partNumber)[0];
    question.value = questions.listening.pages[page];

    if (part.value == null || nextPart.partNumber != part.value.partNumber) {
      currentPartQuestions.value = questions.listening.pages.filter(x => x.partNumber == nextPart.partNumber && !x.example);
    }
    part.value = nextPart;

    const session = await exam.session();

    if (!demo && page < session.answer.listeningProgress) {
      await changePage(session.answer.listeningProgress);
      return;
    }

    if (session.listeningStartTime == null) {
      session.listeningStartTime = (new Date).getTime();
    }

    const audioName = !question.value.example ? question.value.audio : `example_${questions.rank}_part${part.value.partNumber}.m4a`;

    if (audioName) {
      currentAudioName.value = audioName;
      await playAudio(audioName, page);
    }

    session.answer.played[page] = 1;
    session.answer.listeningProgress = page;

    if (question.value.example) {
      selected.value = 0;
      isExample.value = true;
      emit('overridePageName', 'training-test');
    }
    else {
      selected.value = session.answer.listening[page];
      isExample.value = false;
      if (!selected.value) {
        session.noAnswerCount += 1;
      } else {
        session.noAnswerCount = 0;
      }
      emit('overridePageName', 'test');
    }
    await exam.updateSession(session);
  }
  catch(e) {
    app.log(e);
    countdownTimerId = setTimeout(async() => {
      await updatePage(page);
    }, 3000);
  }
}

// 音声再生
const playAudio = async (audioName: string, page: number) => {
  if (!app) return;
  app.stopAudio();
  const example = question.value && question.value.example;
  app.unsetAudioEndedEventListener();

  if (!example) {
    app.setAudioEndedEventListener(async () => {
      app.log(`ListeningTest playAudio end`);
      await playJingleAudio(page);
    });
    app?.playAudioUrl(baseAudioUrl + audioName, false)
        .catch(() => {
          app.stopAudio();
          showRetryModal.value = true;
        });
  }
  else {
    app.setAudioEndedEventListener(async () => {
      app.log(`ListeningTest playAudio end`);
      await playExampleNextAudio(page);
    });
    app?.playAudioUrl(baseAudioUrl + audioName, false)
        .catch(() => {
          app.stopAudio();
          showRetryModal.value = true;
        });
  }
}

const playJingleAudio = async (page: number) => {
  if (!app) return;
  app.unsetAudioEndedEventListener();
  app.playAudioUrl(baseAudioUrl + 'jingle.m4a', false);

  jingleTime.value = 3;
  countdownTimerId = setTimeout(async() => {
    jingleTime.value = 0;
    await changePage(page + 1);
  }, jingleTime.value * 1000);
}

const playExampleNextAudio = async(page: number) => {
  countdownTimerId = setTimeout(async() => {
    await changePage(page + 1);
  }, 1000);
}

// ページ切り替え
const changePage = async (page: number, back = false) => {
  if (!app || !exam) return;
  app.stopAudio();
  const questions = await exam.questions();

  if (page < questions.listening.pages.length) {
    question.value = null;
    if (questions.listening.pages[page].example) {
      if (!back)
        router.replace(`/cbt/${group}/listening/${page}/flow`);
      else
        router.replace(`/cbt/${group}/listening/${page}`);
    }
    else {
      emit('overridePageName', 'test');
      router.replace(`/cbt/${group}/listening/${page}`);
      if (questions.listening.pages[page - 1]?.example) {
        countdown.value = true;
        countdownTimerId = setTimeout(async() => {
          await updatePage(page);
        }, 3000);
      }
      else {
        await updatePage(page);
      }
    }
  }
  // 終了
  else {
    app.stopAudio();
    await exam.listeningEnd();

    // リーディングテストが無い場合がある
    if (questions.reading.pages.length <= 0) {
      await exam.readingEnd();
      router.replace(`/cbt/${group}/end`);
    }
    else {
      router.replace(`/cbt/${group}/reading-caution`);
    }
  }
}

// 問題選択
const selectAnswer = async(val: number) => {
  await exam?.answerListening(currentPage.value, val, isExample.value);
  selected.value = val
}

// ページ読み込み時
onMounted( async() => {
  currentPage.value = parseInt(typeof route.params.page === 'string' ? route.params.page : route.params.page[0]);
  await updatePage(currentPage.value);

  mounted.value = true;
});

// アニメーション
const pageBeforeEnter = (el: HTMLElement) => {
  el.style.opacity = '0'
}
const pageEnter = (el: HTMLElement) => {
  gsap.to(el, {duration: 0.5, opacity: 1, delay: 0.2, ease: 'power3.easeOut'});
}


// モーダルを閉じる
const closeModal = () => {
  showRetryModal.value = false;
}

// 音声再取得
const retryAudio = async() => {
  showRetryModal.value = false;
  await playAudio(currentAudioName.value, currentPage.value);
}

const demoPrev = async () => {
  if (!exam) return;
  app?.stopAudio()
  if (countdownTimerId) {
    clearTimeout(countdownTimerId);
    countdownTimerId = null;
  }
  const questions = await exam.questions();
  if (questions.listening.pages[currentPage.value].example) {
    router.replace(`/cbt/${group}/listening/${currentPage.value}/training`);
  } else {
    updatePage(currentPage.value - 1);
  }
}
const demoNext = () => {
  if (countdownTimerId) {
    clearTimeout(countdownTimerId);
    countdownTimerId = null;
  }
  if (countdown.value) {
    countdown.value = false;
    updatePage(currentPage.value + 1);
    return;
  }
  app?.stopAudio()
  changePage(currentPage.value + 1);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (question.value)
      ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
          _createElementVNode("h1", null, [
            _hoisted_2,
            _createElementVNode("span", _hoisted_3, _toDisplayString(question.value.partNumber), 1),
            _hoisted_4
          ]),
          (jingleTime.value > 0)
            ? (_openBlock(), _createBlock(Progress, {
                key: 0,
                sec: jingleTime.value
              }, null, 8, ["sec"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (currentPartQuestions.value && question.value && !question.value.example)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentPartQuestions.value, (mark) => {
            return (_openBlock(), _createElementBlock("li", {
              key: mark.pageNumber,
              class: _normalizeClass({'current': mark.pageNumber === question.value.pageNumber, 'done': mark.pageNumber < question.value.pageNumber})
            }, null, 2))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, {
      appear: "",
      onBeforeEnter: pageBeforeEnter,
      onEnter: pageEnter
    }, {
      default: _withCtx(() => [
        (question.value)
          ? (_openBlock(), _createElementBlock("main", _hoisted_6, [
              _createElementVNode("h2", _hoisted_7, [
                _createElementVNode("span", {
                  class: _normalizeClass(["label", {'example' : question.value.example}])
                }, [
                  (!question.value.example)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(question.value.questions[0].questionNumber), 1))
                    : _createCommentVNode("", true),
                  (question.value.example)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _hoisted_11))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("span", _hoisted_12, [
                  _createElementVNode("span", {
                    class: "en",
                    innerHTML: part.value.directionEn
                  }, null, 8, _hoisted_13),
                  _createElementVNode("span", {
                    class: "jp",
                    innerHTML: part.value.directionJa
                  }, null, 8, _hoisted_14)
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                (mounted.value && part.value.layout === 1)
                  ? (_openBlock(), _createBlock(Layout1, {
                      question: question.value,
                      key: question.value.pageNumber
                    }, null, 8, ["question"]))
                  : _createCommentVNode("", true),
                (mounted.value && part.value.layout === 2)
                  ? (_openBlock(), _createBlock(Layout2, {
                      question: question.value,
                      key: question.value.pageNumber
                    }, null, 8, ["question"]))
                  : _createCommentVNode("", true),
                (mounted.value && part.value.layout === 3)
                  ? (_openBlock(), _createBlock(Layout3, {
                      question: question.value,
                      key: question.value.pageNumber
                    }, null, 8, ["question"]))
                  : _createCommentVNode("", true),
                (mounted.value && part.value.layout === 6)
                  ? (_openBlock(), _createBlock(Layout6, {
                      question: question.value,
                      key: question.value.pageNumber
                    }, null, 8, ["question"]))
                  : _createCommentVNode("", true),
                (mounted.value && part.value.layout === 8)
                  ? (_openBlock(), _createBlock(Layout8, {
                      question: question.value,
                      key: question.value.pageNumber
                    }, null, 8, ["question"]))
                  : _createCommentVNode("", true),
                (_openBlock(), _createBlock(Answer, {
                  selected: selected.value,
                  question: question.value,
                  onSelectAnswer: selectAnswer,
                  key: question.value.pageNumber
                }, null, 8, ["selected", "question"]))
              ])
            ], 512))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (countdown.value)
      ? (_openBlock(), _createBlock(Countdown, { key: 2 }))
      : _createCommentVNode("", true),
    (showRetryModal.value)
      ? (_openBlock(), _createBlock(RetryModal, {
          key: 3,
          onClose: closeModal,
          onRetry: retryAudio
        }))
      : _createCommentVNode("", true),
    _createVNode(DemoControl, {
      onPrev: demoPrev,
      onNext: demoNext
    })
  ], 64))
}
}

})